// extracted by mini-css-extract-plugin
module.exports = {"sectionPhone":"styles_sectionPhone__1TBFX","hiddenSection":"styles_hiddenSection__PMs8v","contFormPhone":"styles_contFormPhone__2OUKY"};